<style>
        @media print, screen {
            .cont-etiqueta, h3 {
                position: relative;
                font-family: "Helvetica Neue", Helvetica, Arial, sans-serif
            }

            .cont-etiqueta img {
                position: absolute;
                z-index: 30;
                width: 100%;
                height: auto;
            }

            .cont-etiqueta .etiqueta-3 {
                position: absolute;
                top: 220px;
                font-weight: bolder;
                left: 126px;
                color: #ffffff !important;
                font-size: 20px;
                z-index: 40;
            }

            .cont-etiqueta .etiqueta-4 {
                top: 260px;
                left: 43px;
                position: absolute;
                font-weight: bolder;
                font-size: 10px;
                z-index: 40;
                color: #000000 !important;
            }

            .cont-etiqueta .flecha {
                position: absolute;
                width: 25px;
                height: auto;
                background: url('assets/img/etiquetado-flecha.png') no-repeat center center;
                background-size: 25px auto;
                text-align: center;
                font-weight: bolder;
                color: #ffffff !important;
            }

            .cont-etiqueta .flecha-izq {
                display: none;
                left: 79px;
                z-index: 40
            }

            .cont-etiqueta .flecha-der {
                display: none;
                left: 152px;
                z-index: 40
            }

            .cont-etiqueta .flecha-a {
                display: block;
                top: 79px;
                z-index: 40
            }

            .cont-etiqueta .flecha-b {
                display: block;
                top: 93px;
                z-index: 40
            }

            .cont-etiqueta .flecha-c {
                display: block;
                top: 107px;
                z-index: 40
            }

            .cont-etiqueta .flecha-d {
                display: block;
                top: 121px;
                z-index: 40
            }

            .cont-etiqueta .flecha-e {
                display: block;
                top: 135px;
                z-index: 40
            }

            .cont-etiqueta .flecha-f {
                display: block;
                top: 149px;
                z-index: 40
            }

            .cont-etiqueta .flecha-g {
                display: block;
                top: 163px;
                z-index: 40
            }

            .efficiency-tag-new__qr {
                top: 8%;
                right: 1%;
                width: 18%;
            }

            .efficiency-tag-new__brand, .efficiency-tag-new__provider {
                top: 16%;
            }

            .efficiency-tag-new__provider, .efficiency-tag-new__class {
                right: 3%;
            }

            .efficiency-tag-new__size, .efficiency-tag-new__class {
                top: 23%;
            }

            .efficiency-tag-new__brand, .efficiency-tag-new__size {
                left: 3%;
            }

            .efficiency-tag-new__noise {
                left: 15%;
                bottom: 8.6%;
                font-size: 8px;
                line-height: 8px;
            }

            .efficiency-tag-new__gas {
                right: 53%;
            }

            .efficiency-tag-new__gas--c, .efficiency-tag-new__rain--c {
                top: 59.5%;
            }

            .efficiency-tag-new__gas--a, .efficiency-tag-new__gas--b, .efficiency-tag-new__gas--c, .efficiency-tag-new__gas--d, .efficiency-tag-new__gas--e, .efficiency-tag-new__gas--f, .efficiency-tag-new__gas--g, .efficiency-tag-new__rain--a, .efficiency-tag-new__rain--b, .efficiency-tag-new__rain--c, .efficiency-tag-new__rain--d, .efficiency-tag-new__rain--e, .efficiency-tag-new__rain--f, .efficiency-tag-new__rain--g {
                display: block;
            }

            .efficiency-tag-new__gas--a,.efficiency-tag-new__rain--a {
                top: 44.5%;
            }

            .efficiency-tag-new__gas--b,.efficiency-tag-new__rain--b {
                top: 51.5%;
            }

            .efficiency-tag-new__gas--c,.efficiency-tag-new__rain--c {
                top: 59.5%;
            }

            .efficiency-tag-new__gas--d,.efficiency-tag-new__rain--d {
                top: 66.5%;
            }

            .efficiency-tag-new__gas--e, .efficiency-tag-new__rain--e {
                top: 73.5%;
            }

            .efficiency-tag-new__gas  {
                line-height: 14px;;
            }
            .efficiency-tag-new__rain {
                right: 3%;
                line-height: 14px;
            }
            .efficiency-tag-new__gas--b, .efficiency-tag-new__rain--b {
                top: 51.5%;
            }

            .efficiency-tag-new__noise {
                left: 15%;
                bottom: 8.6%;
                font-size: 8px;
                line-height: 8px;
            }
            .efficiency-tag-new__honda {
                left: 20%;
                bottom: -1%;
                font-size: 6px;
                line-height: 10px;
            }

            .efficiency-tag-new__honda--a .efficiency-tag-new__honda-a {
                font-size: 10px;
                font-weight: 600;
            }

            .efficiency-tag-new__honda--b .efficiency-tag-new__honda-b {
                font-size: 10px;
                font-weight: 600;
            }

            .efficiency-tag-new__honda--c .efficiency-tag-new__honda-c {
                font-size: 10px;
                font-weight: 600;
            }
        }
    </style>
    <div id="etiqueta">
        <div style="width:190px" *ngIf="showOldLabel(onda)">
            <h3>{{ nombre }}<br/>{{ marca }}</h3>
            <p class="cont-etiqueta">
                <img src="assets/img/neumatico-etiqueta.jpg"/>
                <span class="etiqueta-3">{{ ruido }}</span>
                <span class="etiqueta-4">{{ etiquetado2 }}</span>
                <span class="flecha flecha-izq flecha-{{ consumo.toLowerCase() }}">
                    <img src="assets/img/etiquetado-flecha.png" style="left:0px; top: -1px;"/>
                </span>
                <span class="flecha flecha-izq flecha-{{ consumo.toLowerCase() }}">
                    {{ consumo }}
                </span>
                <span class="flecha flecha-der flecha-{{ agarre.toLowerCase() }}">
                    <img src="assets/img/etiquetado-flecha.png" style="left:0px; top: -1px;"/>
                </span>
                <span class="flecha flecha-der flecha-{{ agarre.toLowerCase() }}">
                    {{ agarre }}
                </span>
            </p>
        </div>
        <div style="width:190px; position: relative;" *ngIf="!showOldLabel(onda)">
            <img class="efficiency-tag-new__img" src="assets/img/neumatico-etiqueta-new-completa.png" *ngIf="hielo === '1' && nieve === '1'">
            <img class="efficiency-tag-new__img" src="assets/img/neumatico-etiqueta-new-basica.png" *ngIf="hielo !== '1' && nieve !== '1'">
            <img class="efficiency-tag-new__img" src="assets/img/neumatico-etiqueta-new-nieve.png" *ngIf="hielo !== '1' && nieve === '1'">
            <img class="efficiency-tag-new__img" src="assets/img/neumatico-etiqueta-new-hielo.png" *ngIf="hielo === '1' && nieve !== '1'">

            <!-- QR -->
            <qrcode *ngIf="qr != ''" class="efficiency-tag-new__qr" [qrdata]="qr" usesvg="true"></qrcode>
            <!-- Marca -->
            <p class="efficiency-tag-new__brand">{{marca}}</p>
            <!-- Proveedor -->
            <p class="efficiency-tag-new__provider">{{provider}}</p>
            <!-- Tamaño -->
            <p class="efficiency-tag-new__size">{{ancho}}/{{perfil}}R{{llanta}} {{carga}}{{velocidad}}</p>
            <!-- Clase -->
            <p class="efficiency-tag-new__class">{{etiquetado2}}</p>
            <!-- Ruido -->
            <p class="efficiency-tag-new__noise">{{ruido}}</p>
            <!-- Consumo -->
            <p class="efficiency-tag-new__gas efficiency-tag-new__gas--{{consumo | lowercase}}">{{consumo}}</p>
            <!-- Agarre -->
            <p class="efficiency-tag-new__rain efficiency-tag-new__rain--{{agarre | lowercase}}">{{agarre}}</p>
            <!-- Ruido -->
            <p class="efficiency-tag-new__noise">{{ruido}}</p>
            <!-- Honda -->
            <!--
                TODO: Modificadores:
                    .efficiency-tag-new__honda--a
                    .efficiency-tag-new__honda--b
                    .efficiency-tag-new__honda--c
            -->
            <p class="efficiency-tag-new__honda efficiency-tag-new__honda--{{onda | lowercase}}">
                <span class="efficiency-tag-new__honda-a">A</span>
                <span class="efficiency-tag-new__honda-b">B</span>
                <span class="efficiency-tag-new__honda-c">C</span>
            </p>
        </div>
    </div>
